import { motion } from "framer-motion";
import FadeLeftWhenVisible from "../components/Fadeleft";
import FadeRightWhenVisible from "../components/Faderight";
import AnchorLink from "react-anchor-link-smooth-scroll";
import About from "../components/About";
import Carousel from "../components/Carousel";
import Contact from "../components/Contact";
import headerimage from "../assets/customer-support-background.jpeg";
import Service from "../components/Service";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../components/ErrorFallback";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel as ReactCarousel } from "react-responsive-carousel";

function Home() {
  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <main id="home" className="container main space-y-16">

          <header className="header md:grid md:gap-8 md:grid-cols-2 grid">
            <FadeLeftWhenVisible>
              <article className="header-text font-medium md:col-start-1">
                <h1>
                247 Comcare
              </h1>
              <span className="text-xl sm:text-3xl text-blue-900">Telecom Monetization & Digital Entertainment Solutions</span>
                {/* <p>
                  247 Comcare offers personalized customer service and efficient
                  back-office solutions tailored to meet the needs of thriving
                  startups and contemporary enterprises. Our primary goal is to
                  offer great value-added services while using our experience in
                  seamless integration with industry-leading aggregators and VAS
                  providers.
                </p> */}
                <p className="text-blue-900">Powering Mobile Revenue Across Emerging Markets</p>
                <ReactCarousel
                  autoPlay={true}
                  interval={4000}
                  infiniteLoop={true}
                  showArrows={false}
                  showStatus={false}
                  showThumbs={false}
                  swipeable={true}
                  emulateTouch={true}
                >
                  {slides.map((slide) => (
                    <p key={slide.title} className="text-left">
                      {slide.title}
                    </p>
                  ))}
                </ReactCarousel>
                {/* <p>
                  Our primary goal is to offer great value-added services while
                  using our experience in seamless integration with
                  industry-leading aggregators and VAS providers.
                </p> */}
                <AnchorLink href="#contact">
                  <motion.button
                    whileHover={{ scale: 1.1 }}
                    className="btn header-btn"
                  >
                    Get Started
                  </motion.button>
                </AnchorLink>
              </article>
            </FadeLeftWhenVisible>
            <FadeRightWhenVisible>
              <article className="header-image">
                <img
                  src={headerimage}
                  className="header-img"
                  alt=" support woman with headphones working on a computer"
                />
              </article>
            </FadeRightWhenVisible>
          </header>

          <About />

          <Service />
        </main>

        <section className="customer-section flex flex-col items-center mt-16">
          <h2 className="text-2xl font-bold mt-10">Area Of Expertise</h2>
          <Carousel />
        </section>
        <Contact />


      </ErrorBoundary>
    </>
  );
}
export default Home;

const slides = [
  {
    title:
      "247 Comcare delivers enterprise-grade Direct Carrier Billing (DCB), Value-Added Services (VAS), Gaming Platforms, and CRBT solutions for Mobile Network Operators, aggregators, and digital partners.",
  },
  {
    title:
      "We design secure, compliant, and scalable monetization systems built for today’s mobile-first generation.",
  },
];
